module.exports = __webpack_public_path__ + "static/media/strongest-logo-black.6a561e76.svg";